import * as React from 'react';
import { primaryDimensionListContext } from './context';
export var PrimaryDimensionListContextProvider = function (props) {
    var primaryDimensionList = props.primaryDimensionList, children = props.children;
    return (React.createElement(primaryDimensionListContext.Provider, { value: primaryDimensionList }, children));
};
